import {
  Modal,
  Breadcrumb,
  Descriptions,
  Tabs,
  Spin,
  message,
  Table,
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import Head from "../../../layout/head/Head";
import dayjs from "dayjs";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
} from "../../../components/Component";
import { Popconfirm } from "antd/lib";
import React, { useEffect, useState, FC } from "react";
import { projectsApis } from "../../../api/projects";
import { Alert, Card } from "reactstrap";
import { Content } from "antd/es/layout/layout";

interface UserData {
  accessibility?: any[];
  [key: string]: any;
}
interface ProjectInDetailModalProps {
  visible: boolean;
  onClose: () => void;
  activeTab: string;
  userData: UserData;
}

const UserDetailView: FC<{
  activeTab: string;
  userData: UserData;
}> = ({ activeTab, userData }) => {
  // Function to generate tab items based on accessibility data
  const generateAccessibilityTabs = () => {
    if (!userData?.accessibility) return [];
    return userData.accessibility.map((accessItem) => {
      // For Reports category which has nested modules
      if (accessItem.category === "Reports") {
        return {
          label: accessItem.category,
          key: accessItem.category.toLowerCase().replace(/\s+/g, "-"),
          children: (
            <div className="p-4">
              {accessItem.modules.map((reportCategory: any) => (
                <div
                  key={reportCategory.category}
                  style={{ marginBottom: "2rem" }}
                >
                  <h5>{reportCategory.category}</h5>
                  <Table
                    columns={[
                      {
                        title: "Sub-Feature",
                        dataIndex: "moduleName",
                        key: "moduleName",
                      },
                      {
                        title: "View",
                        dataIndex: "actions",
                        key: "view",
                        render: (actions) =>
                          actions.view ? (
                            <Icon
                              name="check-circle-fill"
                              className="text-success"
                            />
                          ) : (
                            <Icon
                              name="cross-circle-fill"
                              className="text-danger"
                            />
                          ),
                      },
                    ]}
                    dataSource={reportCategory.modules}
                    pagination={false}
                    size="small"
                    bordered
                  />
                </div>
              ))}
            </div>
          ),
        };
      }

      // For Dashboard category which has different actions
      if (accessItem.category === "Dashboard") {
        return {
          label: accessItem.category,
          key: accessItem.category.toLowerCase().replace(/\s+/g, "-"),
          children: (
            <div className="p-4">
              <Table
                columns={[
                  {
                    title: "Feature",
                    dataIndex: "moduleName",
                    key: "moduleName",
                  },
                  {
                    title: "Access",
                    dataIndex: "actions",
                    key: "access",
                    render: (actions) =>
                      actions.view ? (
                        <Icon
                          name="check-circle-fill"
                          className="text-success"
                        />
                      ) : (
                        <Icon
                          name="cross-circle-fill"
                          className="text-danger"
                        />
                      ),
                  },
                ]}
                dataSource={accessItem.modules}
                pagination={false}
                size="small"
                bordered
              />
            </div>
          ),
        };
      }

      // For other categories (Masters, Inventory, etc.)
      return {
        label: accessItem.category,
        key: accessItem.category.toLowerCase().replace(/\s+/g, "-"),
        children: (
          <div className="p-8">
            <Table
              columns={[
                {
                  title: "Feature",
                  dataIndex: "moduleName",
                  key: "moduleName",
                },
                {
                  title: "Create",
                  dataIndex: "actions",
                  key: "add",
                  render: (actions) =>
                    actions.add ? (
                      <Icon name="check-circle-fill" className="text-success" />
                    ) : (
                      <Icon name="cross-circle-fill" className="text-danger" />
                    ),
                },
                {
                  title: "View",
                  dataIndex: "actions",
                  key: "view",
                  render: (actions) =>
                    actions.view ? (
                      <Icon name="check-circle-fill" className="text-success" />
                    ) : (
                      <Icon name="cross-circle-fill" className="text-danger" />
                    ),
                },
                {
                  title: "Edit",
                  dataIndex: "actions",
                  key: "edit",
                  render: (actions) =>
                    actions.edit ? (
                      <Icon name="check-circle-fill" className="text-success" />
                    ) : (
                      <Icon name="cross-circle-fill" className="text-danger" />
                    ),
                },
                {
                  title: "Cancel",
                  dataIndex: "actions",
                  key: "cancel",
                  render: (actions) =>
                    actions.cancel ? (
                      <Icon name="check-circle-fill" className="text-success" />
                    ) : (
                      <Icon name="cross-circle-fill" className="text-danger" />
                    ),
                },
                {
                  title: "Approve",
                  dataIndex: "actions",
                  key: "approve",
                  render: (actions) =>
                    actions.approve ? (
                      <Icon name="check-circle-fill" className="text-success" />
                    ) : (
                      <Icon name="cross-circle-fill" className="text-danger" />
                    ),
                },
              ]}
              dataSource={accessItem.modules}
              pagination={false}
              size="small"
              bordered
            />
          </div>
        ),
      };
    });
  };

  // if (!userData) {
  //   return (
  //     <Alert
  //       message="Error"
  //       description="Could not load user data"
  //       type="error"
  //       showIcon
  //       style={{ margin: '20px' }}
  //     />
  //   );
  // }

  return (
    <>
      <Head title="User Details"></Head>
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className="card-inner card-inner-lg"
              style={{ minHeight: "87vh" }}
            >
              {/* {userData && ( */}
              <>
                <Block>
                  <Row className="gy-5">
                    <Col lg="6" sm="12" md="12" xxl="6" size="6" className="">
                      <BlockHead>
                        <BlockBetween>
                          <BlockHeadContent>
                            <BlockTitle tag="h5">
                              Personal Information
                            </BlockTitle>
                            <p>Basic info, like name and contact details...</p>
                          </BlockHeadContent>
                        </BlockBetween>
                      </BlockHead>
                      <Card className="card-bordered">
                        <ul className="data-list is-compact">
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">User ID</div>
                              <div className="data-value">
                                {userData?.referenceID || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">User Name</div>
                              <div className="data-value">
                                {userData?.name || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">
                                Contractor Accessibility
                              </div>
                              <div className="data-value">
                                {userData?.contractorAccessibility?.length > 0
                                  ? userData.contractorAccessibility
                                      .map(
                                        (c: any) =>
                                          c.contractorName || c.companyName
                                      )
                                      .join(", ")
                                  : "None"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">
                                Site Accessibility
                              </div>
                              <div className="data-value">
                                {userData?.siteAccessibility?.length > 0
                                  ? userData.siteAccessibility
                                      .map((s: any) => s.siteName)
                                      .join(", ")
                                  : "None"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Email Address</div>
                              <div className="data-value">
                                {userData?.email || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Phone Number</div>
                              <div className="data-value">
                                {userData?.mobileNumber ||
                                  userData?.phoneNumber ||
                                  "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Country</div>
                              <div className="data-value">
                                {userData?.country?.countryName || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">State</div>
                              <div className="data-value">
                                {userData?.state?.stateName || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">District</div>
                              <div className="data-value">
                                {userData?.district?.districtName || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Area</div>
                              <div className="data-value">
                                {userData?.area || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">PIN</div>
                              <div className="data-value">
                                {userData?.PIN || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Date of Birth</div>
                              <div className="data-value">
                                {userData?.DOB
                                  ? dayjs(userData.DOB).format("DD-MMM-YYYY")
                                  : "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Date of Joining</div>
                              <div className="data-value">
                                {userData?.DOJ
                                  ? dayjs(userData.DOJ).format("DD-MMM-YYYY")
                                  : "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Blood Group</div>
                              <div className="data-value">
                                {userData?.bloodGroup || "--"}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </Card>
                    </Col>

                    <Col lg="6" sm="12" md="12" xxl="6" size="6" className="">
                      <BlockHead>
                        <BlockBetween>
                          <BlockHeadContent>
                            <BlockTitle tag="h5">Hierarchy Setup</BlockTitle>
                            <p>
                              Here is the current status of hierarchy setup.
                            </p>
                          </BlockHeadContent>
                        </BlockBetween>
                      </BlockHead>
                      <Card className="card-bordered">
                        <ul className="data-list is-compact">
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Department</div>
                              <div className="data-value">
                                {userData?.departmentName || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">Role</div>
                              <div className="data-value">
                                {userData?.roleName || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">
                                Reporting Manager Role
                              </div>
                              <div className="data-value">
                                {userData?.reportingManagerRoleName || "--"}
                              </div>
                            </div>
                          </li>
                          <li className="data-item">
                            <div className="data-col">
                              <div className="data-label">
                                Reporting Manager
                              </div>
                              <div className="data-value">
                                {userData?.reportingManagerName || "--"}
                              </div>
                            </div>
                          </li>
                          {userData?.startDate && (
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">Start Date</div>
                                <div className="data-value">
                                  {dayjs(userData.startDate).format(
                                    "DD-MMM-YYYY"
                                  )}
                                </div>
                              </div>
                            </li>
                          )}
                          {userData?.endDate && (
                            <li className="data-item">
                              <div className="data-col">
                                <div className="data-label">End Date</div>
                                <div className="data-value">
                                  {dayjs(userData.endDate).format(
                                    "DD-MMM-YYYY"
                                  )}
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>
                      </Card>
                    </Col>
                  </Row>

                  {/* Accessibility Section */}
                  <Row className="gy-5 mt-4">
                    <Col
                      lg="12"
                      sm="12"
                      md="12"
                      xxl="12"
                      size="12"
                      className=""
                    >
                      <BlockHead>
                        <BlockBetween>
                          <BlockHeadContent>
                            <BlockTitle tag="h5">Accessibility</BlockTitle>
                            <p>User access permissions and settings</p>
                          </BlockHeadContent>
                        </BlockBetween>
                      </BlockHead>
                      <Tabs
                        defaultActiveKey={activeTab || "masters"}
                        items={generateAccessibilityTabs()}
                        className="detail-view-tabs"
                      />
                    </Col>
                  </Row>
                </Block>
              </>
              {/* )} */}
            </div>
          </div>
        </Card>
      </Content>
    </>
  );
};

// Main modal component that wraps the UserDetailView
const ProjectInDetailModal: FC<ProjectInDetailModalProps> = ({
  visible,
  onClose,
  activeTab,
  userData: initialUserData,
}) => {
  const [currentUserData, setCurrentUserData] = useState<UserData>({
    accessibility: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Only fetch if modal is visible and we don't have detailed data yet
    if (visible && initialUserData?.userDetailId) {
      fetchUserDetails();
    }
  }, [visible, initialUserData?.userDetailId]);

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const response = await projectsApis.fetchBuyerById(
        initialUserData.userDetailId
      );
      if (response.status) {
        setCurrentUserData(response.data || {});
      } else {
        message.error("Failed to fetch user details");
        setCurrentUserData({});
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      message.error("Error fetching user details");
      setCurrentUserData({});
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Modal open={visible} onCancel={onClose} footer={null} width={"99%"}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          <Spin tip="Loading user details..." size="large" />
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      className="detail-view-modal"
      maskClosable={false}
      title={
        <div className="d-flex justify-content-start align-items-center">
          <Breadcrumb
            items={[
              {
                title: <HomeOutlined />,
              },
              {
                title: "User Details",
              },
              {
                title:
                  currentUserData?.name || currentUserData?.userName || "--",
              },
              {
                title: currentUserData?.createdDate
                  ? dayjs(currentUserData.createdDate).format("DD-MMM-YYYY")
                  : "--",
              },
            ]}
          />
          <Popconfirm
            placement="right"
            title={<></>}
            icon={<></>}
            showCancel={false}
            trigger="hover"
            okButtonProps={{
              style: {
                display: "none",
              },
            }}
            description={
              <div className="d-flex flex-column">
                <Descriptions
                  title="Quick Info"
                  bordered
                  column={1}
                  size="small"
                  className="custom-description-title"
                >
                  <Descriptions.Item label="Status">
                    {currentUserData?.status || "Active"}
                  </Descriptions.Item>
                  <Descriptions.Item label="User ID">
                    {currentUserData?.referenceID ||
                      currentUserData?.userDetailId ||
                      "--"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {currentUserData?.createdDate
                      ? dayjs(currentUserData.createdDate).format("DD-MMM-YYYY")
                      : "--"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created By">
                    {currentUserData?.createdByUserName ||
                      currentUserData?.createdBy ||
                      "--"}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            }
          >
            <div style={{ display: "inline-block", padding: "2px" }}>
              <Icon
                name="info"
                className="ms-1"
                style={{
                  cursor: "pointer",
                }}
              />
            </div>
          </Popconfirm>
        </div>
      }
      style={{ top: 8 }}
      width={"99%"}
      open={visible}
      footer={null}
      onCancel={onClose}
    >
      {/* {currentUserData &&
        <UserDetailView
          activeTab={activeTab}
          userData={currentUserData}
        />
      } */}
      <UserDetailView
        activeTab={activeTab}
        userData={currentUserData as UserData}
      />
    </Modal>
  );
};

export default ProjectInDetailModal;
